import React, { useState, useEffect } from 'react';
import { observer } from 'mobx-react';
import { useContext } from 'react';
import { Container, Box, Typography, Button } from '@mui/material';
import { useTheme } from '@mui/material/styles';
//
import { AppContext } from '/@/app/AppContext';
import { Value } from '/@/app/views/AgeCalculatorView/Value';
import { ValueListState } from '/@/app/views/AgeCalculatorView/ValueListState';
import Grid from '@mui/material/Grid';
import { styled } from '@mui/material/styles';
import { Spinner } from '/@/app/components/Spinner';
import { useMediaQuery } from '@mui/material';
import { useApi} from '/@/app/Api';


export const ValueItem = styled(Box)(({ theme }) => ({
    ...theme.typography.body2,
    margin: theme.spacing(1),
    textAlign: 'center',
    color: theme.palette.text.secondary,

    // content to bottom,
    // so it will align with neighboring items on wide screens
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    flexFlow: 'column nowrap',
}));


export const AgeCalculatorView = () => {
    const api=useApi();
    const panel = useContext(AppContext).bootstrapData.panel;
    // Create MobX state & wrap the view.
    const listState = new ValueListState([], panel.id, api);
    listState.fetch();
    return <_AgeCalculatorView listState={listState} />;
}


const _AgeCalculatorView = observer(({ listState }) => {
    const panel = listState.panel;
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

    const saveAndCalculate = () => {
        if (listState.saveState === "saving") { return; }
        listState.saveAll();
    };
    const clear = () => {
        if (listState.saveState === "saving") { return; }
        listState.resetOnServer();
    };

    if (listState.saveState === "fetching") {
        return (
            <Container maxWidth="sm" sx={{ mb: 4, textAlign: "center" }}>
                <Spinner size={80} />
            </Container>
        )
    }

    return (
        <Container maxWidth="sm" sx={{ mb: 4 }}>
            {isMobile ?
                <>
                    <Box sx={{ position: "fixed", top: theme.custom.appBarHeight, left: "0", right: "0",
                        backgroundColor: "white", zIndex: 1000, boxShadow: "0 2px 4px rgba(0,0,0,0.1)"
                    }}>
                        <Typography variant="h6" gutterBottom sx={{ textAlign: "center", mt: 1 }}>
                            {panel.age_calculator_caption}
                        </Typography>
                        <Typography variant="h3" sx={{ textAlign: "center", mb: 0 }}>
                            {panel.age_calculator_age !== null &&
                                Math.round(panel.age_calculator_age * 10)/10
                            }
                        </Typography>
                        <Box sx={{ mt: 0, mb: 2, display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'center', gap: 2 }}>
                            <Button variant="contained" color="primary" onClick={saveAndCalculate}>
                                {listState.saveState === "saving" && <Spinner size={20} sx={{ mr: 1, color: "white" }} />}
                                Пересчитать
                            </Button>
                            <Button variant="outlined" color="error" onClick={clear}>
                                {listState.saveState === "resetting" && <Spinner size={20} sx={{ mr: 1, color: theme.palette.error.main }} />}
                                Cбросить
                            </Button>
                        </Box>
                    </Box>
                    <Box sx={{ height: "180px" }}></Box>
                    <Typography variant="body1" gutterBottom sx={{ mb: 4 }}>
                        {panel.age_calculator_description}
                    </Typography>
                </>
                :
                <Box>
                    <Typography variant="h5" gutterBottom sx={{ textAlign: "center" }}>
                        {panel.age_calculator_caption}
                    </Typography>
                    <Typography variant="h1" sx={{ textAlign: "center" }}>
                        {panel.age_calculator_age !== null &&
                            Math.round(panel.age_calculator_age * 10)/10
                        }
                    </Typography>
                    <Typography variant="body1" gutterBottom sx={{ mb: 4 }}>
                        {panel.age_calculator_description}
                    </Typography>
                    <Box sx={{ mt: 2, mb: 4, display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'center', gap: 2 }}>
                        <Button size="large" variant="contained" color="primary" onClick={saveAndCalculate}>
                            {listState.saveState === "saving" && <Spinner size={20} sx={{ mr: 1, color: "white" }} />}
                            Пересчитать
                        </Button>
                        <Button size="large" variant="outlined" color="error" onClick={clear}>
                            {listState.saveState === "resetting" && <Spinner size={20} sx={{ mr: 1, color: theme.palette.error.main }} />}
                            Cбросить
                        </Button>
                    </Box>
                </Box>
            }

            <Grid container spacing={2} sx={{ }}>
                {listState.values.map((state, idx) => (
                    <Grid item xs={12} md={6} key={idx} sx={{
                        // reduce the space between items
                        paddingTop: "0!important",
                        // content to bottom,
                        // so it will align with neighboring items on wide screens
                        display: 'flex',
                        alignItems: 'stretch',
                        justifyContent: 'center',
                        flexFlow: 'column nowrap',
                    }}>
                        <ValueItem>
                            <Value mState={state} key={idx} sx={{ mt: 1, mb: 1 }} />
                        </ValueItem>
                    </Grid>
                ))}
            </Grid>
        </Container>
    );
});


